
jQuery(function($){

    $(document).on('wpcf7mailsent', function(e) {

        const apiResp = e.originalEvent?.detail?.apiResponse || null;

        const n8n = apiResp?.n8n || null;

        if (!n8n) return;

        //const $box = $('#n8n-result');
        //if (!$box.length) return;

        let text = '';

        if (typeof n8n.message === 'string') {
            text = n8n.message;
        } else if (typeof n8n.raw === 'string') {
            text = n8n.raw;
        } else {
            text = JSON.stringify(n8n);
        }

        //$box.text(text);
    });

});